module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "list_group"
  }, [_vm._l((_vm.$store.state.aIndexMenu), function(ul) {
    return _c('ul', [(ul.sub) ? _c('label', {
      on: {
        "click": function($event) {
          _vm.fnToRouter(ul.path)
        }
      }
    }, [_vm._v(_vm._s(ul.name))]) : _vm._e(), _vm._v(" "), _vm._l((ul.sub), function(i) {
      return (ul.sub) ? _c('li', {
        on: {
          "click": function($event) {
            _vm.fnToRouter(i.path)
          }
        }
      }, [_vm._v(_vm._s(i.name))]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("联系我们")]), _vm._v(" "), _vm._l((_vm.about), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.toWan(item.url)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont",
      class: item.icon
    })])
  })], 2)], 2), _vm._v(" "), _c('footer', [_c('div', [_vm._v("2016版权")]), _vm._v(" "), _c('div', [_vm._v("厦门酷联客电子科技有限公司")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/index/toTop.png")
    },
    on: {
      "click": _vm.toTop
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-b9e67a1c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/footer.vue
// module id = 790
// module chunks = 1